
























































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import InstanceSummary from '@/domain/contract/entity/instances-summary.entity';
import OverviewCardExpandableRow from '../overview-main-card-expandable-row.component.vue';
import RowComponent from '../overview-contract-summary-row.component.vue';
import Header from '../header.json';

@Component({
  components: { RowComponent, VbTooltipSlot, OverviewCardExpandableRow },
  filters: {
    toCurrency: VbDirectives.toCurrency,
  },
})
export default class OverviewInstancesComponent extends Vue {
  @Prop({
    type: InstanceSummary,
  }) private instanceSummary!: InstanceSummary;

  private headers: object[] = [...Header];

  goToView(status: string, withConsumption: string) {
    this.$emit('goToView', status, withConsumption);
  }

  getTooltipDescription(name: string) {
    const description = {
      Ativas: 'Instâncias que estão ativas',
      Inativas: 'Instâncias que estão inativas',
      semVinculo: 'Instâncias que não estão vínculadas a nenhum contrato',
    }
    return description[name];
  }
}
